import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";

@Component({
  selector: "formly-wrapper-tab",
  template: `
    <formly-tabs-tab [title]="title" [disabled]="disabled" [hidden]="hidden">
      <ng-template #fieldComponent> </ng-template>
    </formly-tabs-tab>
  `,
  standalone: false,
})
export class FormlyWrapperTabComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef })
  override fieldComponent!: ViewContainerRef;

  get title(): string {
    return this.props["tabTitle"];
  }

  get disabled(): boolean {
    return this.props["tabDisabled"];
  }

  set disabled(value: boolean) {
    this.props["tabDisabled"] = !!value;
  }

  get hidden(): boolean {
    return this.props["tabHidden"];
  }

  set hidden(value: boolean) {
    this.props["tabHidden"] = !!value;
  }
}
